import { defineComponent as _defineComponent } from 'vue'
import Chevron from '@/components/svg-components/Chevron.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BCXChevronSwitch',
  props: {
  value: { type: Boolean },
  orientationOn: { type: String, default: 'up' },
  orientationOff: { type: String, default: 'down' },
  width: { type: Number, default: 24 },
  height: { type: Number, default: 24 },
  strokeWidth: { type: Number, default: 1 },
  addClickableSpace: { type: String, default: '' }
},
  emits: ['input'],
  setup(__props, { emit }) {

const props = __props;





const click = () => {
  emit('input', !props.value);
};


return { __sfc: true,props, emit, click, Chevron }
}

})